<template>
  <div class="count-box text-center" :class="{ 'has-cursor-pointer': opens }" @click="open">
    <!-- One block, so a box that centres its content with flex (Devices and Actions) keeps it stacked. -->
    <div>
      <!-- Shown above the count, e.g. a status dot. -->
      <slot name="marker" />
      <div class="count-box-value">
        <u v-if="link">{{ value }}</u>
        <template v-else>{{ value }}</template>
      </div>
      <div class="count-box-label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

/**
 * A bordered count with its label, as on the flexiShuttle dashboard's tiles. As a link (the default) it opens its
 * list, except for a zero or missing count. Padding and size come from the parent (`p-4`, a min-height...).
 */
export default {
  name: 'DashboardCountBox',
  props: {
    value: {
      type: [Number, String],
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    link: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['open'],
  setup(props, { emit }) {
    const opens = computed(() => props.link && !!props.value);
    const open = () => {
      if (opens.value) emit('open');
    };
    return { opens, open };
  },
};
</script>

<style lang="scss" scoped>
.count-box {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  height: 100%;
}

.count-box-value {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.count-box-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
}
</style>
